import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogActions, DialogTitle, Card, CardContent, CardActionArea, Typography, IconButton, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import { useTranslation } from 'react-i18next'
import CloseIcon from '@mui/icons-material/Close';

const InfoCategory = ({ open, setOpen, selectedRow, rows }) => {
    const {t} = useTranslation()
    const [name, setName] = useState('')
    const [createdBy, setCreatedBy] = useState('')
    const [createdAt, setCreatedAt] = useState('')
    const [updatedBy, setUpdatedBy] = useState('')
    const [updatedAt, setUpdatedAt] = useState('')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (open && selectedRow) {
            const select = rows.find(row => row.id === selectedRow[0])
            setName(select?.name)
            setCreatedBy(select?.created_at)
            setCreatedAt(select?.created_by)
            setUpdatedBy(select?.updated_at)
            setUpdatedAt(select?.updated_by)
            setLoading(false)
        }
    }
    , [open, selectedRow, rows])

    const clearForm = () => {
        setOpen(false)
        setName('')
        setCreatedBy('')
        setCreatedAt('')
        setUpdatedBy('')
        setUpdatedAt('')
        setLoading(true)
    }

    return (
        <Dialog
            maxWidth="xs"
            fullWidth
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    return
                }
                clearForm()
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <IconButton
                aria-label="close"
                onClick={() => clearForm()}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogTitle id="alert-dialog-title">{t('custom_reports.category.table.dialog.info.title')}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12}}>
                        <Card>
                            <CardActionArea
                                sx={{
                                height: '100%',
                                '&[data-active]': {
                                    backgroundColor: 'action.selected',
                                    '&:hover': {
                                    backgroundColor: 'action.selectedHover',
                                    },
                                },
                                }}
                            >
                                <CardContent>
                                    <Typography variant="body1">{t('custom_reports.category.table.dialog.info.name')} : {name}</Typography>

                                    <Typography variant="body1">{t('custom_reports.category.table.dialog.info.create_by')} : {createdBy}</Typography>

                                    <Typography variant="body1">{t('custom_reports.category.table.dialog.info.create_at')} : {createdAt}</Typography>

                                    <Typography variant="body1">{t('custom_reports.category.table.dialog.info.update_by')}: {updatedBy}</Typography>

                                    <Typography variant="body1">{t('custom_reports.category.table.dialog.info.update_at')} : {updatedAt}</Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" loading={loading} onClick={() => clearForm(false)}>{t('custom_reports.category.table.dialog.info.buttons.close')}</Button>
            </DialogActions>

        </Dialog>
    )
}

export { InfoCategory };